import React from 'react';
import { Modal } from '@components/v2/Modal';
import { translate } from '@utils/i18n';
import { DYNE_CONTACT, NAMESPACE } from '../constants';
import '../SprinklerSamplingIndex.scss';
function ContactDyneModal({ onClose }) {
    return (React.createElement(Modal, { title: translate('contact_dyne', { namespace: NAMESPACE }), isOpen: true, onClose: onClose, width: "500px" },
        React.createElement("div", { className: "contact-dyne-items" },
            React.createElement("a", { href: `mailto:${DYNE_CONTACT.email}`, className: "contact-dyne-link" },
                React.createElement("i", { className: "fa-light fa-envelope" }),
                React.createElement("span", null, DYNE_CONTACT.email)),
            React.createElement("a", { href: `tel:${DYNE_CONTACT.phone}`, className: "contact-dyne-link" },
                React.createElement("i", { className: "fa-light fa-phone" }),
                React.createElement("span", null, DYNE_CONTACT.phone)))));
}
export default ContactDyneModal;
